module.exports = __webpack_public_path__ + "static/media/7.50a9a452.jpg";